import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-guest-match-info-grid",
  templateUrl: "./guest-match-info-grid.component.html",
  styleUrls: ["./guest-flow.component.css"],
  standalone: false
})
export class GuestMatchInfoGridComponent {
  @Input() public timeLabel = "";
  @Input() public timeValue = "";
  @Input() public timeDetail = "";
  @Input() public locationLabel = "";
  @Input() public locationValue = "";
  @Input() public locationDetail = "";
  @Input() public timeClickable = false;
  @Input() public locationClickable = false;

  @Output() public timeClick = new EventEmitter<void>();
  @Output() public locationClick = new EventEmitter<void>();
}
